export default {
  container: {
    marginTop: "72px",
    marginBottom: "48px",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "1200px",
  },
};
